import React from 'react';

const EnvContext = React.createContext();

const EnvProvider = (props) => {
  return (
    <EnvContext.Provider value={props.value}>
      {props.children}
    </EnvContext.Provider>
  );
};

export { EnvContext, EnvProvider}
